import React from 'react';

function Methodology(props) {
    return (
        <div>
            <p>
                A thorough background analysis was undertaken at the project's early stages to confirm the project's
                necessity and societal impact. Our system contains four main components. Each component uses different
                Machine Learning algorithms.
            </p>
            <ul>
                <li>Plant Diseases Detection Traditional ML (CNN).</li>
                <li>Plant Diseases Detection AutoML.</li>
                <li>Market Price Forecasting LSTM Model.</li>
                <li>Food Banking Concept and Direct Buy and Sell Requester Rating model.</li>
            </ul>
            <p>
                The resulted output of this whole system is a mobile phone application. Farmers, Sellers, Potential
                Suppliers, Marketing Centers, Agriculture-Related Shops, Agri Students and Lecturers, Authorities, and
                the general public are among those who utilize our system. At the beginning of the GreenHub LK
                application, we intend to offer the mobile application available for free in the App Store and the Play
                Store. Our system incurs no additional expenditures as a result of our use of FOSS services. There will
                be other features for commercial use as well.
            </p>
            <ol>
                <div className="row">
                    <div className="col-lg-5 col-md-6">
                        <li> Plant Disease Identification</li>
                        <img height="500px"
                             src={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fkavindi%20diagram.png?alt=media&token=34538609-7d6d-4da9-ba3e-c3d0a7c959d4"}
                             border="1px" alt="kavindi"/>
                    </div>
                    <div className="col-lg-5 col-md-6">
                        <li> Testing the suitability of using Auto ML for plant disease identification</li>
                        <img height="500px"
                             src={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fwasana%20diagram.png?alt=media&token=2a03dc64-b62d-482c-8cd6-bf650f4aff6e"}
                             border="1px" alt="hiruni"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5 col-md-6">
                        <li> Harvest price forecasting</li>
                        <img height="500px"
                             src={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2FSenura%20diagram.png?alt=media&token=edd4b047-055f-48f2-861a-534cb26d8f6e"}
                             alt="senura"/>
                    </div>
                    <div className="col-lg-5 col-md-6">
                        <li> Food banking and direct buy and sell</li>
                        <img height="500px"
                             src={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2FViraj%20Diagram.png?alt=media&token=f3840561-608c-4580-b0e8-20224d596f45"}
                             border="1px" alt="viraj"/>
                    </div>
                </div>
            </ol>
        </div>
    );
}

export default Methodology;
